import { useFormContext } from "react-hook-form";
import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { useMemo } from "react";
import { formatarValorMonetario } from "../../../../../../../../../../helpers/masks";
import { usePermission } from "../../../../../../../../../../components/PermissionGuard";

export default function AlertMarcarDescontoCompensacao({
    total_pagar
}:AlertMarcarDescontoCompensacaoProps ) {
    const { setValue, watch } = useFormContext();

    const totalAtt = watch('total_atualizado');
    const valueRadio = watch('finalizacao.aplicarDiferencaComoDesconto')

    const permissaoDesconto = usePermission('financeiro.contas-receber-permitir-desconto')

    const { perguntarSobreDesconto, diffValor, precisaPermissao } = useMemo(() => {
        let totalValor = 0
        const params: TInternParams = {
            perguntarSobreDesconto: false,
            diffValor: 0,
            precisaPermissao: false,
        }
        if (total_pagar > 0) {
            totalValor = total_pagar
            params.perguntarSobreDesconto = totalValor < totalAtt ? true : false
            params.diffValor = totalAtt - totalValor
            params.precisaPermissao = (totalAtt - totalValor) > 0.99 ? true : false
        }
        return params
    }, [total_pagar, totalAtt])

    const handleChangeRadio = (value: boolean) => {
        setValue('finalizacao.aplicarDiferencaComoDesconto', value)
    }

    const podeAplicarDesconto = useMemo(() => {
        return perguntarSobreDesconto && (!precisaPermissao || (precisaPermissao && permissaoDesconto));
    }, [perguntarSobreDesconto, precisaPermissao, permissaoDesconto])

    useMemo(() => {
        if(!podeAplicarDesconto) {setValue('finalizacao.aplicarDiferencaComoDesconto', false)}
    }, [podeAplicarDesconto, setValue])

    if (podeAplicarDesconto) return (
        <Box
            p={2}
            borderRadius={1}
            bgcolor="#fff4e5"
            sx={{ color: "#663c00" }}
            mb={2}
        >
            <Typography variant="subtitle2">
                A soma dos valores informados abaixo é menor que o total atualizado. Gostaria de aplicar o valor de <b>{formatarValorMonetario(diffValor)}</b> como um desconto e registrar a compensação do(s) título(s)?
            </Typography>

            <FormControl>
                <RadioGroup
                    row
                    aria-labelledby="aplicar-como-desconto"
                    value={valueRadio}
                    onChange={(e) => handleChangeRadio(e.target.value as any)}
                >
                    <FormControlLabel value={true} control={<Radio color="warning" size="small" />} label="Sim" />
                    <FormControlLabel value={false} control={<Radio color="warning" size="small" />} label="Não" />
                </RadioGroup>
            </FormControl>
        </Box>
    )

    return (<></>)
}

type TInternParams = {
    perguntarSobreDesconto: boolean;
    diffValor: number;
    precisaPermissao: boolean;
}

interface AlertMarcarDescontoCompensacaoProps  {
    total_pagar: number
}